import { Helmet } from 'react-helmet';
import { getOrganizationSchema, getLocalBusinessSchema, getFAQSchema, getBreadcrumbSchema } from '@/utils/seoSchemas';

/**
 * Composant SEOHead réutilisable pour toutes les pages
 * Gère les meta tags, Open Graph, Twitter Cards, Canonical et JSON-LD
 */
export default function SEOHead({
  title,
  description,
  canonical,
  ogType = 'website',
  ogImage = 'https://images.pexels.com/photos/36343876/pexels-photo-36343876.jpeg?auto=compress&cs=tinysrgb&w=1200',
  schemas = [],
  robots = 'index, follow'
}) {
  const fullTitle = title;
  const siteUrl = 'https://homely-conciergerie.ch';
  
  return (
    <Helmet>
      {/* Meta de base */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical || siteUrl} />
      
      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical || siteUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:locale" content="fr_CH" />
      
      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* JSON-LD Schemas */}
      {schemas.map((schema, index) => (
        <script
          key={`schema-${index}`}
          type="application/ld+json"
        >
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
}
